function LocalUser() {
    if (typeof localStorage !== 'undefined') {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch (e) {
            localStorage.removeItem('user');
        }
    }
    return null;
}

const localUser = LocalUser();

import Api from '@/services/api'
import router from '@/router/index';
import ability from '@/config/ability'

import { LOGIN, LOGOUT, REGISTER, REFRESHTOKEN, EDIT_USER_DETAILS, EDIT_USER_PROFILE, ADD_ALERT, LOAD_PROFILES, ADD_USER, EDIT_USER, REMOVE_USER, EDIT_USER_PASSWORD } from '@/store/_actiontypes'
import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_USER, UPDATE_USER_DETAILS, UPDATE_USER_PROFILE, SET_PROFILES, DELETE_USER } from '@/store/_mutationtypes'

const state = {
    user: localUser ? localUser : null,
    currencies: [],
    profilelist: []
};

const actions = {
    [LOGIN]({ commit }, { email, password }) {
        Api.post('/login', {
                email,
                password
            })
            .then(response => {
                let user = response.data;
                commit(LOGIN_SUCCESS, user);

                try { this.$ability.update() } catch (error) {
                    console.log(error.message) /* "Only Admins can create Posts" */
                }
                router.push('/dashboard');
            })
            .catch(() => {
                commit(LOGIN_FAILURE);
            });
    },
    [REGISTER]({ dispatch }, { email, firstName, lastName, password, useDarkMode, accountType }) {
        Api.post('/register', {
                email,
                firstName,
                lastName,
                password,
                useDarkMode,
                accountType
            })
            .then(() => {
                dispatch(`alert/${ADD_ALERT}`, { message: 'User registered successfully', color: 'success' }, { root: true });
                router.push('/dashboard');
            });
    },
    [ADD_USER]({ dispatch }, { email, firstName, lastName, password, useDarkMode, accountType }) {
        Api.post('/register', {
                email,
                firstName,
                lastName,
                password,
                useDarkMode,
                accountType
            })
            .then(() => {
                dispatch(`alert/${ADD_ALERT}`, { message: 'User registered successfully', color: 'success' }, { root: true });
            });
    },
    [REFRESHTOKEN]({ commit }, { refreshtoken, token }) {
        return Api.post('/refreshtoken', {
                token,
                refreshtoken
            })
            .then(response => {
                let user = response.data;
                commit(LOGIN_SUCCESS, user);
            })
            .catch((e) => {
                commit(LOGIN_FAILURE);
            });
    },
    [LOGOUT]({ commit }) {
        commit(LOGOUT_USER);
    },
    [EDIT_USER_DETAILS]({ commit }) {
        commit(UPDATE_USER_DETAILS);
    },
    [EDIT_USER_PROFILE]({ commit, dispatch }, { firstName, lastName, useDarkMode, accountType }) {
        return Api.put('/profile', {
                firstName,
                lastName,
                useDarkMode,
                accountType
            })
            .then(response => {
                commit(UPDATE_USER_PROFILE, response.data);
                dispatch(`alert/${ADD_ALERT}`, { message: 'Profile updaded successfully', color: 'success' }, { root: true });
            })
    },
    [LOAD_PROFILES]({ commit }) {
        Api.post('/profiles')
            .then(response => {
                let vData = response.data;
                commit(SET_PROFILES, vData);
            })
    },
    [EDIT_USER]({ commit, dispatch }, { id, email, firstName, lastName, password, accountType, useDarkMode }) {
        return Api.put(`/user/${id}`, { id, email, firstName, lastName, password, accountType, useDarkMode })
            .then(response => {
                if (localUser.email == email)
                    commit(UPDATE_USER_PROFILE, response.data);
                dispatch(`alert/${ADD_ALERT}`, { message: 'Profile updaded successfully', color: 'success' }, { root: true });
            });
    },
    [EDIT_USER_PASSWORD]({ dispatch }, { email, password }) {
        return Api.post(`/changepassword`, { email, password })
            .then(() => {
                dispatch(`alert/${ADD_ALERT}`, { message: 'User password change successfully', color: 'success' }, { root: true });
            });
    },
    [REMOVE_USER]({ commit, dispatch }, { id }) {
        Api.delete(`/user/${id}`)
            .then(() => {
                commit(DELETE_USER, id);
                dispatch(`alert/${ADD_ALERT}`, { message: 'User deleted successfully', color: 'success' }, { root: true });
            })
    },


};

const mutations = {
    [LOGIN_SUCCESS](state, user) {
        // login successful if there's a jwt token in the response
        if (user.token) {
            // store user details and jwt token in local storage
            localStorage.setItem('user', JSON.stringify(user));
        }
        state.user = user;
    },
    [LOGIN_FAILURE](state) {
        state.user = null;
    },
    [LOGOUT_USER](state) {
        // remove user from local storage 
        localStorage.removeItem('user');
        state.user = null;
    },
    [UPDATE_USER_DETAILS](state) {
        state.user.useDarkMode = !state.user.useDarkMode;
    },
    [UPDATE_USER_PROFILE](state, { firstName, lastName, fullName, useDarkMode, accountType }) {
        state.user.firstName = firstName;
        state.user.lastName = lastName;
        state.user.fullName = fullName;
        state.user.useDarkMode = useDarkMode;
        state.user.theme = useDarkMode == true ? 'dark' : 'light';
        state.user.accountType = accountType;

    },
    [SET_PROFILES](state, data) {
        state.profilelist = data;
    },
    [DELETE_USER](state, id) {
        state.profilelist = state.profilelist.filter(h => h.id != id)
    }


};

const getters = {
    nameInitials: (state) => {
        if (state.user == undefined) return;
        var initials = state.user.fullName.match(/\b\w/g) || [];
        return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
    }
}

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};